import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { value, ownerDocument } = button
    const wrapper = one('.ea_designsystem__page', ownerDocument)
    const position = value === 'on' ? 'inline' : 'top'
    
    wrapper.classList.remove('ea_pref__label_position-top')
    wrapper.classList.remove('ea_pref__label_position-inline')
    wrapper.classList.add('ea_pref__label_position-' + position)
  }
})

export default button => {
  onClick.listen(button)
}
